import { useEffect, useRef, MutableRefObject } from "react"

import gsap from "gsap"

const useFadeIn = (
  onScroll = true,
  vars: gsap.TweenVars = {}
): MutableRefObject<HTMLElement | null> => {
  const elementRef = useRef<HTMLElement | null>(null)
  useEffect(() => {
    gsap.fromTo(
      elementRef.current,
      { y: 60 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        delay: 0.3,
        ease: "expo.out",
        scrollTrigger: onScroll
          ? { trigger: elementRef.current as HTMLElement, once: true }
          : undefined,
        ...vars,
      }
    )
  }, [onScroll, vars])

  return elementRef
}

export default useFadeIn
